var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.98398 8.99471C7.72573 8.99471 7.46748 8.88303 7.26087 8.68758L0.417134 2.26582C0.184705 2.04246 0.0297522 1.73533 0.00392675 1.40028C-0.0218987 1.06523 0.081403 0.730184 0.262181 0.450977C0.442959 0.199691 0.727039 0.0321674 1.03694 0.00424667C1.34685 -0.0236741 1.63093 0.0880079 1.86336 0.283453L7.98398 6.06304L14.1046 0.534738C14.2337 0.423055 14.3629 0.339294 14.492 0.311373C14.6469 0.255532 14.7761 0.255532 14.931 0.255532C15.086 0.283452 15.2151 0.311373 15.3701 0.395134C15.4992 0.478896 15.6283 0.590579 15.7058 0.730183C15.8091 0.869787 15.8866 1.00939 15.9382 1.17691C15.9899 1.34444 16.0157 1.51196 15.9899 1.70741C15.964 1.87493 15.9382 2.04246 15.8607 2.20998C15.7833 2.3775 15.68 2.48919 15.5508 2.60087L8.68127 8.77134C8.47467 8.93887 8.21641 9.02263 7.98398 8.99471Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/down-icon.84b767d45ceebc4e76f323c9ab9485f7.svg";
export { ForwardRef as ReactComponent };